import React from 'react'
import ButtonHoverAnimated from '../../../../components/Buttons/ButtonHoverAnimated'
import image7 from '../../../assets/Illustrations/2149489784.jpg'
import image2 from '../../../assets/Illustrations/jhvgc gkbhycx.png'


import ButtonBlack from '../../../../components/Buttons/ButtonBlack'
import { useNavigate } from 'react-router-dom'



const Trainings = () => {
    const navigate = useNavigate()
  return (
    <div className='w-full py-10 lg:py-20 px-6 lg:px-20 xl:px-40 bg-[rgb(245,255,210)] grid grid-cols-1 lg:grid-cols-2  gap-10' >
  <div><img src={image7} alt="" className='h-[300px] lg:h-[450px] w-full object-cover rounded-md' /></div>
  <div className="col-span-1 space-y-6 flex flex-col justify-between items-start">
  <p className="text-lg font-semibold bg-primary-green px-1 text-start">
    Recruter les meilleurs talents
  </p>
  <img src={image2} alt="" className='size-36 rotate-12 object-cover rounded-md absolute ml-80 -mt-40' />
  <div className="space-y-6">
    <h2 className="text-2xl lg:text-4xl font-extrabold text-start leading-normal">
      Trouvez les talents d’exception pour votre entreprise
    </h2>
    <p className="text-start text-base lg:text-lg">
      Accédez à une communauté de professionnels qualifiés et de jeunes talents en formation. 
      Trouvez les experts qui correspondent à vos besoins.
    </p>
    <div className="justify-start flex">
      <ButtonBlack onClick={() => navigate("candidat")} DefaultClassName="px-8 py-4 text-lg rounded-sm">
        Découvrir les talents
      </ButtonBlack>
    </div>
  </div>
</div>

</div>
  
  
  )
}

export default Trainings